export const flights = [
  {
    id: 1,
    from: "New York (JFK)",
    to: "Paris (CDG)",
    airline: "Air France",
    price: 449,
    tripType: "Round Trip",
    cabinClass: "Economy",
    duration: "7h 30m",
    stops: "Non-stop",
    dates: "Multiple dates available"
  },
  {
    id: 2,
    from: "London (LHR)",
    to: "Dubai (DXB)",
    airline: "Emirates",
    price: 389,
    tripType: "Round Trip",
    cabinClass: "Economy",
    duration: "6h 50m",
    stops: "Non-stop",
    dates: "Multiple dates available"
  },
  {
    id: 3,
    from: "Los Angeles (LAX)",
    to: "Tokyo (NRT)",
    airline: "ANA",
    price: 599,
    tripType: "Round Trip",
    cabinClass: "Economy",
    duration: "11h 15m",
    stops: "Non-stop",
    dates: "Multiple dates available"
  },
  {
    id: 4,
    from: "Chicago (ORD)",
    to: "Rome (FCO)",
    airline: "Alitalia",
    price: 519,
    tripType: "Round Trip",
    cabinClass: "Economy",
    duration: "9h 45m",
    stops: "Non-stop",
    dates: "Multiple dates available"
  },
  {
    id: 5,
    from: "Miami (MIA)",
    to: "Cancún (CUN)",
    airline: "American Airlines",
    price: 299,
    tripType: "Round Trip",
    cabinClass: "Economy",
    duration: "3h 10m",
    stops: "Non-stop",
    dates: "Multiple dates available"
  },
  {
    id: 6,
    from: "San Francisco (SFO)",
    to: "Sydney (SYD)",
    airline: "Qantas",
    price: 749,
    tripType: "Round Trip",
    cabinClass: "Economy",
    duration: "15h 30m",
    stops: "1 Stop",
    dates: "Multiple dates available"
  }
];
